import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Pagination,
  alpha,
  Divider,
} from "@mui/material";
import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

const COPYTRADINGSERVICE = WEBSERVICE + "/copyTrading";

const CopyTradingHistory = () => {
  const navigate = useNavigate();
  const { brokerBasicInfo, btncolor, brokerMarkets } = useSelector((state) => state);
  const [exchanageName, setExchanageName] = useState("");
  const subscriptionPrice = 25;

  const themeColor = localStorage.getItem("theme");
  const [tradeApiKeyStatus, setTradeApiKeyStatus] = useState(true);
  const [botTraderStatus, setBotTraderStatus] = useState(undefined);
  const [traderName, setTraderName] = useState(null);
  const [exchangeName, setExchangeName] = useState("PAYBITO");
  const [timePeriod, setTimePeriod] = useState("All Time");
  const [traderNameFilter, setTraderNameFilter] = useState("");
  const [marketType, setMarketType] = useState("");
  const [baseCurrency, setBaseCurrency] = useState("All");
  const [viewType, setViewType] = useState("");
  const [botSelect, setBotSelect] = useState("");
  const [botList, setBotList] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [itemNo, setItemNo] = useState(50);
  const [pgn, setPgn] = useState([]);
  const [noOfRecords, setNoOfRecords] = useState(null);
  const [botTableList, setBotTableList] = useState([]);
  const [orderView, setOrderView] = useState(true);
  const [marketSelected, setMarketSelected] = useState(false);
  const [exchangeSelected, setExchangeSelected] = useState(false);
  const [botSelected, setBotSelected] = useState(false);
  const [apiPublicKey, setApiPublicKey] = useState(null);
  const [apiSecretKey, setApiSecretKey] = useState(null);
  const [getDataButton, setGetDataButton] = useState(false);
  const [apiKeyId, setApiKeyId] = useState(null);
  const [orderDtls, setOrderDtls] = useState(null);
  const [buttonDeleteStatus, setButtonDeleteStatus] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);

  const itemsPerPage = 10;
  const totalPages = Math.ceil(botTableList?.length / itemsPerPage);

  useEffect(() => {
    getBotList();
  }, [marketType, exchanageName]);
  useEffect(() => {
    getList();
  }, [pageNo]);

  const getBotList = () => {
    if (marketType !== "") {
      setMarketSelected(true);
      setExchangeSelected(true);
    }
    const addAPI = {
      marketType: marketType,
      exchange_name: exchanageName === "BINANCE" ? "BINANCE" : "PAYBITO",
      customerId: localStorage.getItem("userId"),
      role: localStorage.getItem("traderRole"),
    };
    axios
      .post(`${COPYTRADINGSERVICE}/bot/getBotsForHistory`, JSON.stringify(addAPI), {
        headers: {
          "content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        setBotList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching bot list:", error);
      });
  };

  const changeBotdrop = () => {
    setBotSelect("");
    if ("" === "") {
      setBotSelected(false);
      setViewType("");
    }
  };

  const enableBotDrop = () => {
    if (botSelect !== "") {
      setBotSelected(true);
    }
  };

  const getListFromButton = () => {
    setOrderView(viewType === 1);
    const addAPI = {
      pageNo: 1,
      view_type: viewType,
      customerId: localStorage.getItem("userId"),
      botId: botSelect,
      itemNo: itemNo,
    };
    axios
      .post(`${COPYTRADINGSERVICE}/bot/getTradesOffresForHistory`, JSON.stringify(addAPI), {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const data = response.data;
        setBotTableList(data.tradeOfferViews);
        setNoOfRecords(data.no_of_records);
        setApiPublicKey(data.apiKey);
        setApiSecretKey(data.secretKey);
        setApiKeyId(data.apiKeyId);
        setOrderDtls(data.orderdtls[0]);
        const pages = [];
        for (let i = 1; i <= Math.ceil(data.no_of_records / itemNo); i++) pages.push(i);
        setPgn(pages);
        getList();
      })
      .catch((error) => {
        console.error("Error fetching trade offers history:", error);
      });
  };

  const getList = () => {
    setOrderView(viewType === 1);
    const addAPI = { pageNo, view_type: viewType, customerId: localStorage.getItem("userId"), botId: botSelect, itemNo };
    axios
      .post(`${COPYTRADINGSERVICE}/bot/getTradesOffresForHistory`, JSON.stringify(addAPI), {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const data = response.data;
        setBotTableList(data.tradeOfferViews);
        setNoOfRecords(data.no_of_records);
        setApiPublicKey(data.apiKey);
        setApiSecretKey(data.secretKey);
        setApiKeyId(data.apiKeyId);
        setOrderDtls(data.orderdtls?.[0] || null);
        const pageArray = [];
        for (let i = 1; i <= Math.ceil(data.no_of_records / itemNo); i++) pageArray.push(i);
        setPgn(pageArray);
      })
      .catch((error) => {
        console.error("Error fetching trade offers:", error);
      });
  };

  const removeBotHistory = (exchangeName, orderId, symbol, txn_type, price) => {
    setButtonDeleteStatus(true);
    const customerId = localStorage.getItem("userId");
    const token = localStorage.getItem("access_token");
    const addAPI = {
      apiKey: apiPublicKey,
      secretKey: apiSecretKey,
      exchange_name: exchangeName,
      market: marketType,
      orderId,
      symbol,
      customerId,
      apiKeyId,
      price,
      selling_asset_code:
        txn_type.toLowerCase() === "buy"
          ? orderDtls.SELLING_ASSET_CODE.toUpperCase()
          : orderDtls.BUYING_ASSET_CODE.toUpperCase(),
      buying_asset_code:
        txn_type.toLowerCase() === "buy"
          ? orderDtls.BUYING_ASSET_CODE.toUpperCase()
          : orderDtls.SELLING_ASSET_CODE.toUpperCase(),
      txn_type: txn_type.toLowerCase() === "buy" ? 1 : 2,
      margin_type: orderDtls.MARGIN_TYPE,
      leverage: orderDtls.LEVERAGE,
      asset_pair: orderDtls.ASSET_PAIR,
    };
    axios
      .post(`${COPYTRADINGSERVICE}/bot/cancelOrderForOther`, addAPI, {
        headers: { "Content-Type": "application/json", Authorization: `BEARER ${token}` },
      })
      .then((response) => {
        setButtonDeleteStatus(false);
        if (response.data.statusCode === 1) showToast("success", response.data.message);
        else showToast("error", response.data.message);
        getList();
      })
      .catch((error) => {
        setButtonDeleteStatus(false);
        showToast("error", "An error occurred while canceling the order.");
        console.error(error);
      });
  };

  const removeBotHistoryPaybito = async (exchangeName, orderId, symbol, txn_type, PRICE) => {
    setButtonDeleteStatus(true);
    const uuid = localStorage.getItem("uuid");
    const accessToken = localStorage.getItem("access_token");
    let inputObj = {};
    let newtxn;

    if (marketType === "Spot") {
      inputObj.offer_id = orderId;
      if (txn_type === "buy") {
        inputObj.selling_asset_code = orderDtls.SELLING_ASSET_CODE.toUpperCase();
        inputObj.buying_asset_code = orderDtls.BUYING_ASSET_CODE.toUpperCase();
        newtxn = 1;
      } else {
        inputObj.selling_asset_code = orderDtls.BUYING_ASSET_CODE.toUpperCase();
        inputObj.buying_asset_code = orderDtls.SELLING_ASSET_CODE.toUpperCase();
        newtxn = 2;
      }
      inputObj.amount = "0"; inputObj.txn_type = newtxn; inputObj.price = PRICE;
      inputObj.uuid = uuid; inputObj.assetCode = orderDtls.ASSET_CODE; inputObj.orderType = orderDtls.ORDER_TYPE;
      try {
        const response = await axios.post(`${WEBSERVICE}userTrade/TradeManageOffer`, inputObj, {
          headers: { "content-Type": "application/json", authorization: `BEARER ${accessToken}` },
        });
        setButtonDeleteStatus(false);
        if (response.data.error.error_data !== 0) { showToast("error", response.data.error.error_msg); getList(); }
        else { alert("success", response.data.error.error_msg); getList(); }
      } catch (error) { console.error(error); setButtonDeleteStatus(false); }
    } else {
      inputObj.offer_id = orderId;
      if (txn_type === "buy") {
        inputObj.selling_asset_code = orderDtls.SELLING_ASSET_CODE.toUpperCase();
        inputObj.buying_asset_code = orderDtls.BUYING_ASSET_CODE.toUpperCase();
        newtxn = 1;
      } else {
        inputObj.selling_asset_code = orderDtls.BUYING_ASSET_CODE.toUpperCase();
        inputObj.buying_asset_code = orderDtls.SELLING_ASSET_CODE.toUpperCase();
        newtxn = 2;
      }
      inputObj.assetPair = orderDtls.ASSET_PAIR; inputObj.amount = "0"; inputObj.txn_type = newtxn;
      inputObj.price = PRICE; inputObj.offerType = orderDtls.OFFER_TYPE; inputObj.leverage = orderDtls.LEVERAGE;
      inputObj.uuid = uuid; inputObj.marginType = orderDtls.MARGIN_TYPE;
      inputObj.assetCode = orderDtls.ASSET_CODE; inputObj.orderType = orderDtls.ORDER_TYPE;
      try {
        const response = await axios.post(`${WEBSERVICE}fTrade/TradeManageOffer`, inputObj, {
          headers: { "content-Type": "application/json", authorization: `BEARER ${accessToken}` },
        });
        if (response.data.error.error_data !== 0) { showToast("error", response.data.error.error_msg); getList(); }
        else { showToast("success", response.data.error.error_msg); getList(); }
      } catch (error) { console.error(error); }
      finally { setButtonDeleteStatus(false); }
    }
  };

  const followTrader = () => { setSubscriptionOpen(false); };
  const handlePageChange = (event, value) => { setPageNo(value); };

  const tableColumns = [
    "Transaction ID", "Exchange ID", "Symbol", "Date", "Type",
    orderView ? "Order ID" : "Trade ID", "Price", "Amount", "Total Value",
    ...(orderView ? ["Action"] : []),
  ];

  return (
    <Box sx={pageWrapper}>
      {/* Hero Banner */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(btncolor || "#1976d2", 0.95)} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <AutoStoriesOutlinedIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={heroTitle}>Copy-Trading History</Typography>
            <Typography sx={heroSubtitle}>
              View your bot trade history — open offers and completed trades
            </Typography>
          </Box>
          <ContainedButton
            variant="contained"
            onClick={() => navigate("/copy-trade")}
            sx={backBtn}
          >
            Back
          </ContainedButton>
        </Box>
      </Box>

      {/* Filter Card */}
      <Box sx={filterCard}>
        <Box sx={filterHeader}>
          <FilterAltOutlinedIcon sx={{ ...filterHeaderIcon, color: btncolor }} />
          <Typography sx={filterHeaderText}>Filter History</Typography>
        </Box>
        <Box sx={filterGrid}>
          <Select
            fullWidth
            value={marketType}
            onChange={(e) => { setMarketType(e.target.value); changeBotdrop(); }}
            displayEmpty
            sx={modernSelectStyle}
          >
            <MenuItem value="">Select Market</MenuItem>
            <MenuItem value="Spot">Spot</MenuItem>
            {brokerMarkets?.isFutures === 1 && (
              <MenuItem value="Futures">Futures</MenuItem>
            )}
          </Select>

          {marketType && (
            <Select
              fullWidth
              value={exchanageName}
              onChange={(e) => { setExchanageName(e.target.value); changeBotdrop(); }}
              displayEmpty
              sx={modernSelectStyle}
            >
              <MenuItem value="">Select Exchange</MenuItem>
              <MenuItem value="BINANCE">BINANCE</MenuItem>
              <MenuItem value="PAYBITO">{brokerBasicInfo?.companyName}</MenuItem>
            </Select>
          )}

          {marketType && exchanageName && (
            <Select
              fullWidth
              value={botSelect}
              onChange={(e) => { setBotSelect(e.target.value); getBotList(); enableBotDrop(); }}
              displayEmpty
              sx={modernSelectStyle}
            >
              <MenuItem value="">Select a Bot</MenuItem>
              {botList?.length !== 0 &&
                botList?.map((bot, i) => (
                  <MenuItem key={bot.bot_id} value={bot.bot_id}>
                    {bot.bot_id} - {bot.bot_name}
                  </MenuItem>
                ))}
            </Select>
          )}

          {marketType && exchanageName && botSelect && (
            <Select
              fullWidth
              value={viewType}
              onChange={(e) => { setViewType(e.target.value); setGetDataButton(true); }}
              displayEmpty
              sx={modernSelectStyle}
            >
              <MenuItem value="">Select View Type</MenuItem>
              <MenuItem value="1">Open Offers</MenuItem>
              <MenuItem value="2">Trades</MenuItem>
            </Select>
          )}

          {getDataButton && (
            <ContainedButton
              variant="contained"
              onClick={getListFromButton}
              sx={filterBtn}
            >
              Get List
            </ContainedButton>
          )}
        </Box>
      </Box>

      {/* Results */}
      <Box sx={mainCard}>
        <Box sx={resultsHeader}>
          <Box>
            <Typography sx={resultsTitle}>Bots History</Typography>
            <Typography sx={resultsCaption}>
              {botTableList?.length || 0} record{botTableList?.length !== 1 ? "s" : ""}
            </Typography>
          </Box>
        </Box>

        <TableContainer component={Paper} sx={modernTableContainer}>
          <Table sx={tableStyle} size="small">
            <TableHead>
              <TableRow sx={modernTableHeadRow}>
                <TableCell sx={modernTableHeadCell}>Transaction ID</TableCell>
                <TableCell sx={modernTableHeadCell}>Exchange ID</TableCell>
                <TableCell sx={modernTableHeadCell}>Symbol</TableCell>
                <TableCell sx={modernTableHeadCell}>Date</TableCell>
                <TableCell sx={modernTableHeadCell}>Type</TableCell>
                <TableCell sx={modernTableHeadCell}>{orderView ? "Order ID" : "Trade ID"}</TableCell>
                <TableCell sx={modernTableHeadCell}>Price</TableCell>
                <TableCell sx={modernTableHeadCell}>Amount</TableCell>
                <TableCell sx={modernTableHeadCell}>Total Value</TableCell>
                {orderView && <TableCell sx={modernTableHeadCell}>Action</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {botTableList?.length > 0 ? (
                botTableList.map((history, index) => (
                  <TableRow key={index} sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>{history.TRANSACTION_ID}</TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.EXCHANGE_ID}</TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.SYMBOL}</TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.TXN_DATE}</TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      <Box
                        sx={{
                          display: "inline-block",
                          px: 1,
                          py: 0.25,
                          borderRadius: "6px",
                          fontSize: "0.72rem",
                          fontWeight: 700,
                          backgroundColor:
                            history.TXN_TYPE?.toLowerCase() === "buy"
                              ? "rgba(22,163,74,0.1)"
                              : "rgba(239,68,68,0.1)",
                          color:
                            history.TXN_TYPE?.toLowerCase() === "buy" ? "#16a34a" : "#ef4444",
                        }}
                      >
                        {history.TXN_TYPE}
                      </Box>
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {orderView ? history.ORDER_ID : history.TRADE_ID}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.PRICE}</TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.AMOUNT}</TableCell>
                    <TableCell sx={modernTableBodyCell}>{history.TOTAL_VALUE}</TableCell>
                    {orderView && (
                      <TableCell sx={modernTableBodyCell}>
                        {(history.EXCHANGE_ID === "BINANCE" || history.EXCHANGE_ID === "PAYBITO") && (
                          <OutlinedButton
                            variant="outlined"
                            size="small"
                            disabled={buttonDeleteStatus}
                            onClick={() =>
                              removeBotHistory(
                                history.EXCHANGE_ID, history.ORDER_ID,
                                history.SYMBOL, history.TXN_TYPE, history.PRICE
                              )
                            }
                            sx={{ borderRadius: "8px", textTransform: "none", fontSize: "0.75rem" }}
                          >
                            Cancel
                          </OutlinedButton>
                        )}
                        {history.EXCHANGE_ID === "YACRYPTO" && (
                          <OutlinedButton
                            variant="outlined"
                            size="small"
                            disabled={buttonDeleteStatus}
                            onClick={() =>
                              removeBotHistoryPaybito(
                                history.EXCHANGE_ID, history.ORDER_ID,
                                history.SYMBOL, history.TXN_TYPE, history.PRICE
                              )
                            }
                            sx={{ borderRadius: "8px", textTransform: "none", fontSize: "0.75rem" }}
                          >
                            Cancel
                          </OutlinedButton>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={orderView ? 10 : 9} sx={emptyCell}>
                    <InboxOutlinedIcon sx={emptyIcon} />
                    <Typography sx={emptyText}>No history records found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {totalPages > 1 && (
          <Box sx={paginationWrap}>
            <Pagination
              count={totalPages}
              page={pageNo}
              boundaryCount={2}
              siblingCount={2}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
              size="small"
              showFirstButton
              showLastButton
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "var(--text-color)",
                  borderColor: "rgba(125,125,125,0.3)",
                },
                "& .Mui-selected": {
                  backgroundColor: `${btncolor} !important`,
                  color: "#fff",
                },
              }}
            />
          </Box>
        )}
      </Box>

      {/* Subscription Dialog */}
      <Dialog open={subscriptionOpen} onClose={() => setSubscriptionOpen(false)} PaperProps={{ sx: dialogPaper }}>
        <DialogTitle sx={dialogTitleStyle}>Subscription Info</DialogTitle>
        <Divider />
        <DialogContent>
          <TextField label="Price" fullWidth value={`${subscriptionPrice} USDT/mo`} margin="dense" InputProps={{ readOnly: true }} />
          <TextField label="Period" fullWidth value="30 days" margin="dense" InputProps={{ readOnly: true }} />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <ContainedButton onClick={followTrader} variant="contained" fullWidth sx={{ borderRadius: "10px", textTransform: "none" }}>
            Subscribe
          </ContainedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

// ── Styles ─────────────────────────────────────────────────────────────────────

const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
  flexWrap: "wrap",
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 540,
};

const backBtn = {
  height: 40,
  px: 2.5,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
  flexShrink: 0,
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.3)",
  color: "#fff",
  "&:hover": { backgroundColor: "rgba(255,255,255,0.28)" },
};

const filterCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  p: { xs: 2, md: 2.5 },
  mb: 2.5,
};

const filterHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mb: 2,
};

const filterHeaderIcon = {
  fontSize: 18,
};

const filterHeaderText = {
  fontSize: "0.85rem",
  fontWeight: 600,
  color: "var(--text-color)",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

const filterGrid = {
  display: "flex",
  flexWrap: "wrap",
  gap: 1.5,
  alignItems: "center",
};

const modernSelectStyle = {
  minWidth: 160,
  maxWidth: 200,
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    fontSize: "0.88rem",
  },
  "& .MuiSelect-select": { color: "var(--text-color)" },
  "& .MuiSvgIcon-root": { color: "var(--text-color)", opacity: 0.7 },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.25)" },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(125,125,125,0.45)" },
};

const filterBtn = {
  height: "48px",
  px: 3,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.85rem",
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  overflow: "hidden",
  p: { xs: 2, md: 2.5 },
};

const resultsHeader = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 1.5,
  mb: 2,
};

const resultsTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const resultsCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.65,
  mt: 0.25,
};

const modernTableContainer = {
  borderRadius: "12px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "none",
  overflowX: "auto",
  backgroundColor: "var(--body-color-less)",
};

const tableStyle = {
  minWidth: 900,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.5,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};

const emptyCell = {
  textAlign: "center",
  py: 7,
  borderBottom: 0,
};

const emptyIcon = {
  fontSize: 48,
  color: "var(--text-color)",
  opacity: 0.35,
  mb: 1,
};

const emptyText = {
  fontSize: "0.92rem",
  color: "var(--text-color)",
  opacity: 0.65,
};

const paginationWrap = {
  display: "flex",
  justifyContent: "flex-end",
  pt: 2,
  mt: 1,
  borderTop: "1px solid rgba(125,125,125,0.12)",
};

const dialogPaper = {
  borderRadius: "16px",
  minWidth: { xs: "85%", sm: 400 },
  boxShadow: "0 24px 60px rgba(0,0,0,0.28)",
  backgroundColor: "var(--popupbody-color)",
  color: "var(--text-color)",
};

const dialogTitleStyle = {
  textAlign: "center",
  fontWeight: 700,
  fontSize: "1.05rem",
  py: 2,
  color: "var(--text-color)",
  backgroundColor: "var(--popupheader-color)",
};

export default CopyTradingHistory;
